const tabButtons = document.querySelectorAll(
	'.block-tab-standard-tab > .wp-block-button .wp-block-button__link'
);

const tabBlocks = document.querySelectorAll('.block-tab-standard-tabs');

const autoCycleDelay = 4000;

const toggleTab = (e) => {
	e.preventDefault();

	const tabBlock = e.currentTarget.closest('.block-tab-standard-tabs');

	if (tabBlock) {
		const activeTabs = tabBlock.querySelectorAll(
			'.block-tab-standard-tab > .wp-block-button.active'
		);

		if (activeTabs.length) {
			activeTabs.forEach((activeTab) => {
				if (activeTab !== e.currentTarget.parentElement) {
					activeTab.classList.remove('active');
					activeTab.parentElement.classList.remove('active');
				}
			});
		}

		e.currentTarget.parentElement.classList.add('active');
		e.currentTarget.parentElement.parentElement.classList.add('active');

		const selectElement = tabBlock.querySelector(
			'.block-tab-standard-tabs__mobile-select'
		);
		const tab = e.currentTarget.closest('.block-tab-standard-tab');

		if (tab && tab.hasAttribute('data-index') && selectElement) {
			selectElement.value = tab.getAttribute('data-index');
		}
	}
};

const mobileSelect = (e) => {
	const tabBlock = e.currentTarget.closest('.block-tab-standard-tabs');

	if (tabBlock) {
		const activeTabs = tabBlock.querySelectorAll(
			'.block-tab-standard-tab > .wp-block-button.active'
		);
		const currentTabButton = tabBlock.querySelector(
			'.block-tab-standard-tab[data-index="' +
				e.currentTarget.value +
				'"] > .wp-block-button'
		);

		if (currentTabButton) {
			if (activeTabs.length) {
				activeTabs.forEach((activeTab) => {
					if (activeTab !== e.currentTarget.parentElement) {
						activeTab.classList.remove('active');
						activeTab.parentElement.classList.remove('active');
					}
				});
			}

			currentTabButton.classList.add('active');
			currentTabButton.parentElement.classList.remove('active');
		}
	}
};

if (tabButtons.length) {
	tabButtons.forEach((tabButton) => {
		tabButton.addEventListener('click', toggleTab);
	});
}

if (tabBlocks.length) {
	tabBlocks.forEach((tabBlock) => {
		let autoCycleInterval;
		let autoCyclePaused = false;
		const tabs = tabBlock.querySelectorAll('.block-tab-standard-tab');

		const pauseAutoCycle = () => {
			if (!autoCyclePaused) {
				autoCyclePaused = true;
			}
		};

		const unpauseAutoCycle = () => {
			if (autoCyclePaused) {
				autoCyclePaused = false;
			}
		};

		if (tabs.length) {
			const selectElement = tabBlock.querySelector(
				'.block-tab-standard-tabs__mobile-select'
			);

			if (!selectElement) {
				return;
			}

			tabs.forEach((tab, index) => {
				const tabButton = tab.querySelector(
					'.block-tab-standard-tab > .wp-block-button'
				);

				tab.addEventListener('mouseenter', pauseAutoCycle);
				tab.addEventListener('focus', pauseAutoCycle);
				tab.addEventListener('mouseleave', unpauseAutoCycle);
				tab.addEventListener('blur', unpauseAutoCycle);

				if (tabButton) {
					const option = document.createElement('option');

					option.value = index;
					option.text = tabButton?.firstElementChild?.innerText
						?.replace(/<br\s*\/?>/gi, ' ')
						?.replace(/&amp;/g, '&');
					selectElement.appendChild(option);
					tab.setAttribute('data-index', index);

					if (index + 1 === tabs.length) {
						selectElement.addEventListener('change', mobileSelect);
						tab.parentElement.appendChild(selectElement);
					}
				}

				tabButton.classList.add('initialized');

				if (0 === index) {
					tabButton.classList.add('active');
					tabButton.parentElement.classList.add('active');
				}
			});
		}

		const cycleTabs = () => {
			if (window.innerWidth < 768) {
				return;
			}

			let activeIndex = 0;

			tabs.forEach((tab, index) => {
				if (tab.classList.contains('active')) {
					activeIndex = index;
				}
			});

			activeIndex++;

			if (activeIndex >= tabs.length) {
				activeIndex = 0;
			}

			const activeTabButton =
				tabs[activeIndex]?.firstElementChild?.firstElementChild;

			const openMenu = document.querySelector(
				'.block-navigation.active, .block-navigation.search-active, .block-navigation.block-navigation--search-open'
			);

			if (
				activeTabButton &&
				activeTabButton.classList.contains('wp-block-button__link') &&
				!openMenu
			) {
				activeTabButton.click();
			}
		};

		const startAutoCycle = () => {
			if (autoCycleInterval) {
				clearInterval(autoCycleInterval);
			}

			autoCycleInterval = setInterval(() => {
				if (!autoCyclePaused) {
					cycleTabs();
				}
			}, autoCycleDelay);
		};

		startAutoCycle();
	});
}
